<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>预警消息</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form
      :inline="true"
      :model="formInline"
      label-position="right"
      label-width="120px"
      class="searchBar"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户名称">
            <el-input
                size="small"
                v-model="formInline.customer"
                placeholder="输入客户名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="状态">
            <el-select
                size="small"
                v-model="formInline.catalog"
                placeholder="请选择预警类型"
            >
              <el-option label="2月未交易" value="1"></el-option>
              <el-option label="未达到利润" value="2"></el-option>
              <el-option label="未达到金额" value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="业务员">
            <el-input
                size="small"
                v-model="formInline.saleMan"
                placeholder="输入业务员"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >搜索</el-button
            >
            <el-button
              size="small"
              type="info"
              icon="el-icon-delete"
              @click="handleReset"
              >清空</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="userData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="index" width="50">
      </el-table-column>
      <el-table-column
        prop="customer"
        label="名称"
        show-overflow-tooltip
        align="center"
        width="250px"
      >
      </el-table-column>
      <el-table-column
          prop="catalog"
          label="预警类型"
          show-overflow-tooltip
          align="center"
          :formatter="handleFormatStatus"
      >
      </el-table-column>
      <el-table-column
          prop="saleMan"
          label="业务员"
          show-overflow-tooltip
          align="center"
          width="250px"
      >
      </el-table-column>
      <el-table-column
        prop="maxProfit"
        label="总利润"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column><el-table-column
        prop="maxSale"
        label="总交易额"
        show-overflow-tooltip
        align="center"
    >
    </el-table-column>

      <el-table-column
        prop="createDate"
        label="预警时间"
        show-overflow-tooltip
        :formatter="handleFormatDate"
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作" width="240" align="center">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
          >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination :pager="pager" @pager="handlePager"></Pagination>
    <!-- 编辑界面 -->
    <EditForm
      :title="title"
      :visible.sync="editFormVisible"
      :edit-form="editForm"
      @confirm="handleEditForm"
    ></EditForm>
  </div>
</template>

<script>
import { listWarn ,deleteWarn} from "@/api/system/warn";
import Pagination from "@/components/pagination";
import EditForm from "./add-edit";
import { timestampToDate } from "@/utils";
import { BTN_PERMS_TYPE } from "@/utils/permissions";

function formatStatus(val) {
  if (val) {
    if(val == 1) return "2月未交易";
    if(val == 2) return "未达到利润";
    if(val == 3) return "未达到金额";
  }

  return "匿名用户";
}
export default {
  filters: {
    formatStatus(val) {
      return formatStatus(val);
    },
  },
  data() {
    return {
      btn_perm_type: BTN_PERMS_TYPE,
      loading: false,
      editFormVisible: false,
      title: "",
      enterpriseType: [
        { key: "全部", value: "" },
        { key: "正常", value: "正常" },
        { key: "异常", value: "异常" },
      ],
      enterpriseCategoryType: [
        { key: "全部", value: "" },
        { key: "企业", value: "企业" },
        { key: "银行", value: "银行" },
      ],
      editForm: {},
      formInline: {
        customer: "",
        catalog: null,
      },
      userData: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 1,
      },
    };
  },
  components: {
    Pagination,
    EditForm,
  },
  created() {
    this.getData(this.formInline);
  },
  methods: {
    handleFormatStatus(row) {
      return formatStatus(row.catalog);
    },
    handleFormatDate(row, column, cellValue) {
      if (cellValue) {
        return timestampToDate(cellValue);
      }

      return cellValue;
    },
    getData() {
      this.loading = true;
      listWarn(this.pager.currentPage, this.pager.pageSize, this.formInline)
        .then(({ content, page, size, totalCount }) => {
          this.userData = content;
          this.pager.currentPage = page;
          this.pager.pageSize = size;
          this.pager.total = totalCount;
        })
        .catch(this.$message.error)
        .finally(() => {
          this.loading = false;
        });
    },
    handlePager(pager) {
      this.pager.currentPage = pager.currentPage;
      this.pager.pageSize = pager.pageSize;
      this.getData();
    },
    handleSearch() {
      this.getData();
    },
    handleReset() {
      this.formInline = {
        status: "",
        customerType: "",
      };
      this.getData();
    },
    handleEdit(row, readonly) {
      if (row) {
        this.title = "修改客户";
        this.editForm = row;
      } else {
        this.title = "添加客户";
        this.editForm = {};
      }
      if (readonly) {
        this.editFormDetailVisible = true;
      } else {
        this.editFormVisible = true;
      }
    },
    handleDelete(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteWarn(row.id)
            .then(() => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.getData();
            })
            .catch(() => {
              this.$message.error("数据删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除！",
          });
        });
    },
    handleEditForm() {
      this.getData();
    },
  },
};
</script>

<style scoped>
.searchBar {
  margin-top: 20px;
  height: 50px;
}
.el-input {
  width: auto !important;
}
</style> 


// WEBPACK FOOTER //
// src/views/system/warn/index.vue